<template>
	<div style="max-width: max(30vw, 400px)" class="text-left tooltip-container">
		<div>
			<span style="font-weight: 600">{{ $t('schedule') }}:</span> {{ event.schedule.scheduleRuleName }}
		</div>
		<div>
			<span style="font-weight: 600">{{ $t('task-list') }}:</span> {{ event.occurrence.occurrenceName }}
		</div>
		<div>
			<span style="font-weight: 600">{{ $t('duration') }}:</span> {{ event.start.toLocaleTimeString() }} -
			{{ event.end.toLocaleTimeString() }}
		</div>
		<div v-if="event.description">
			<span style="font-weight: 600">{{ $t('description') }}:</span>
			<br />
			<span style="white-space: pre-wrap">{{ event.description }}</span>
		</div>
		<div>
			<div style="font-weight: 600">{{ $t('Staff') }}:</div>
			<div class="chip-container">
				<v-chip
					small
					label
					v-for="(executor, index) in event.executors.split(', ').slice(0, 7)"
					:key="index"
					class="chip">
					{{ executor }}
				</v-chip>
				<span v-if="event.executors.split(', ').length > 7">
					+{{ event.executors.split(', ').length - 7 }} {{ $t('more') }}
				</span>
			</div>
		</div>
		<div>
			<span style="font-weight: 600">{{ $t('tasks') }}:</span>
			<ul v-if="event.hasTasks.length">
				<li v-for="(task, index) in event.hasTasks" :key="index">
					{{ task.taskExecutorByName }} - {{ task.taskDetailDescription }}
				</li>
			</ul>
			<span v-else>{{ $t('none') }}</span>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		event: {
			type: Object,
			default: null,
		},
	},
};
</script>

<style scoped>
.tooltip-container > div {
	padding: 4px;
}
.chip-container {
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
}
.chip {
	margin: 0 !important;
}
</style>
